Vue.asyncComponent('ak-toast', {
    props: {
        timeout: {
            type: Number,
            default: 10000
        },
        id: {
            type: Number,
            required: true
        },
        text: {
            type: String,
        },
        level: {
            type: String,
            default: 'info'
        },
        icon: {
            type: String,
        }
    },
    model: {
        prop: 'message',
        event: 'remove'
    },
    methods: {
        remove() {
            this.$emit('remove', this.id);
        }
    },
    created() {
        if (this.timeout) {
            setTimeout(this.remove, this.timeout);
        }
    }
}, 'layout/ak-toast.html');